/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-02-29 17:57:20
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-02-29 17:57:40
 * @FilePath: /chaoyongtuan/src/components/business/uploadBigFileDialog/const.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const IS_WAITING = 'IS_WAITING'; // 等待上传
const ERROR_SIZE = 'ERROR_SIZE'; // 文件大小不符合
const WARN_DURATION = 'WARN_DURATION'; // 建议时长大于4s
const WARN_VIDEO_RADIO = 'WARN_VIDEO_RADIO'; // 建议视频宽高比 16/9  9/16
const UPLOADING = 'UPLOADING'; // 正在上传
const CANCEL = 'CANCEL'; // 取消上传
const SUCCESS = 'SUCCESS'; // 上传成功
const FAIL = 'FAIL'; // 上传失败
const NOT_ENOUGH_SPACE = 'NOT_ENOUGH_SPACE'; // 剩余空间不足
const NAME_TOO_LONG = 'NAME_TOO_LONG'; // 文件名称过长
const TYPE_NOT_SUPPORT = 'TYPE_NOT_SUPPORT'; // 文件格式不支持 兼容windows可以跳过文件过滤的问题
const NAME_REPETITION = 'NAME_REPETITION'; // 文件名字重复

const FILE_STATUS = {
	IS_WAITING,
	ERROR_SIZE,
	WARN_DURATION,
	WARN_VIDEO_RADIO,
	UPLOADING,
	CANCEL,
	SUCCESS,
	FAIL,
	NOT_ENOUGH_SPACE,
	NAME_TOO_LONG,
	TYPE_NOT_SUPPORT,
	NAME_REPETITION
};

export { FILE_STATUS };
